import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { SaleAction } from '../../store/actions';

class Receive extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    receiveSale: PropTypes.func,
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  getInitialState() {
    return {
      amount: '',
      transacted_at: '',
    };
  }

  getTotalPayable(sale) {
    const now = new Date();
    const sold = new Date(sale?.sold_at);
    const yearDiff = now.getFullYear() - sold.getFullYear();
    const monthDiff = now.getMonth() - sold.getMonth();
    const dateDiff = now.getDate() - sold.getDate();
    const totalMonthDiff = yearDiff * 12 + monthDiff + (dateDiff < 0 ? -1 : 0);
    const dueTillNow = Number(sale?.due_till_now);
    const monthlyInterest = Number(sale?.monthly_interest);
    const installments = Number(sale?.installments);
    const totalPayable =
      dueTillNow - monthlyInterest * (installments - totalMonthDiff);
    return Number(totalPayable).toFixed(2);
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.receiveSale(this.props.saleId, this.state);
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Receive Sale</h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col">
                    Installment Payable: {this.props.sale?.monthly_installment}
                  </div>
                  <div className="form-group col">
                    Total Payable: {this.getTotalPayable(this.props.sale)}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="transacted_at">Receive At</label>
                    <input
                      className="form-control"
                      id="transacted_at"
                      name="transacted_at"
                      onChange={this.onChange}
                      placeholder="Receive At"
                      type="date"
                      value={this.state.transacted_at}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="amount">Amount</label>
                    <input
                      className="form-control"
                      id="amount"
                      name="amount"
                      onChange={this.onChange}
                      placeholder="Amount"
                      type="number"
                      value={this.state.amount}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Receive
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
  receiveSale: (id, data) => dispatch(SaleAction.receiveSale(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Receive);
